import { Stamp } from '../models/DailyReport/StampModel';

export class CommonStamp {
  /** いいね */
  public static readonly Good: Stamp = {
    id: 11,
    name: 'いいね!',
  };
}
